import { render, staticRenderFns } from "./attachment-list.vue?vue&type=template&id=781bf094"
import script from "./attachment-list.vue?vue&type=script&lang=js"
export * from "./attachment-list.vue?vue&type=script&lang=js"
import style0 from "./attachment-list.vue?vue&type=style&index=0&id=781bf094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports